import React from 'react';
import { PropTypes } from 'prop-types';
import { Container, Title, Value, SubTitle, Result } from './styles';


const propTypes = {
  info: PropTypes.any
};

export default function Widget({ info }) {
  function sign(val){
    return val.indexOf("-") != -1;
  }

  return (
    <Container>
      <Title>{info.title}</Title>
      { !sign(info.value) ? <Value>{info.value}</Value> : <Value style={{color: "red"}}>{info.value}</Value>  }
      <SubTitle>{info.subtitle}</SubTitle>
      { !sign(info.result) ? <Result>{info.result}</Result> : <Result style={{color: "red"}}>{info.result}</Result> }
    </Container>
  );
}

Widget.propTypes = propTypes;
